var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.macros(_vm.links(_vm.object.text)))}}),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.submit(_vm.object.value)}}},[_vm._v(" Next ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }